import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a7e5bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-3" }, "Are you sure you want to delete this carrier?", -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "account-wrapper pb-5 mt-3" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "carriers-countries-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "py-5 carriers-preloader"
}
const _hoisted_9 = {
  key: 1,
  class: "carriers-countries mt-3 pb-4"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "d-flex align-items-center carrier-country" }
const _hoisted_12 = { class: "row flex-1" }
const _hoisted_13 = { class: "col-8" }
const _hoisted_14 = { class: "col-4 d-flex justify-content-end" }
const _hoisted_15 = { class: "secondary-text text-right" }
const _hoisted_16 = { class: "chevron-right" }
const _hoisted_17 = {
  key: 0,
  class: "col-6"
}
const _hoisted_18 = {
  key: 0,
  class: "py-5 carriers-preloader"
}
const _hoisted_19 = {
  key: 1,
  class: "country-carriers-list"
}
const _hoisted_20 = { class: "country-carrier" }
const _hoisted_21 = { class: "row align-items-center" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "row align-items-center" }
const _hoisted_25 = { class: "col-8 d-flex justify-content-end" }
const _hoisted_26 = { class: "font-15" }
const _hoisted_27 = { class: "col-4" }
const _hoisted_28 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_29 = { class: "pt-2 pb-5 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdateCarrierModal = _resolveComponent("UpdateCarrierModal")!
  const _component_DeleteConfirmDialog = _resolveComponent("DeleteConfirmDialog")!
  const _component_PageMainHeading = _resolveComponent("PageMainHeading")!
  const _component_SearchControl = _resolveComponent("SearchControl")!
  const _component_AppPreloader = _resolveComponent("AppPreloader")!
  const _component_Country = _resolveComponent("Country")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_CustomScrollbar = _resolveComponent("CustomScrollbar")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Partner = _resolveComponent("Partner")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BtnContent = _resolveComponent("BtnContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_UpdateCarrierModal, {
      "edit-data": _ctx.editCarrierData,
      "is-editing": _ctx.isEditing,
      opened: _ctx.updateCarrierModalOpened,
      loading: _ctx.updateLoading,
      onHide: _ctx.discardUpdateCarrier,
      onSubmit: _ctx.submitHandler
    }, null, 8, ["edit-data", "is-editing", "opened", "loading", "onHide", "onSubmit"]),
    _createVNode(_component_DeleteConfirmDialog, {
      opened: _ctx.deleteConfirmDialogOpened,
      loading: _ctx.deleteLoading,
      onHide: _ctx.deleteCancel,
      onCancel: _ctx.deleteCancel,
      onConfirm: _ctx.deleteConfirm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.deleteCarrierName), 1),
          _hoisted_2
        ])
      ]),
      _: 1
    }, 8, ["opened", "loading", "onHide", "onCancel", "onConfirm"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PageMainHeading, { title: "Carriers" }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Card, { title: "Countries" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_SearchControl, {
                    "on-search": () => {},
                    name: "package-search",
                    "field-type": "inline-field",
                    placeholder: "search",
                    "input-timeout": true,
                    onChange: _ctx.searchHandler
                  }, null, 8, ["on-search", "onChange"]),
                  _createVNode(_component_CustomScrollbar, { "max-height": 500 }, {
                    default: _withCtx(() => [
                      _createVNode(_Transition, {
                        name: "fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.countriesLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_component_AppPreloader)
                              ]))
                            : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: country.id,
                                    class: _normalizeClass(["carriers-countries--item", { selected: _ctx.selectedCountryId === country.id }]),
                                    onClick: ($event: any) => (_ctx.selectCountry(country.id))
                                  }, [
                                    _createElementVNode("div", _hoisted_11, [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createVNode(_component_Country, {
                                            "image-path": country.icon,
                                            name: country.name
                                          }, null, 8, ["image-path", "name"])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                          _createElementVNode("span", _hoisted_15, _toDisplayString(country.operators.length) + " carriers ", 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_SvgIcon, {
                                          icon: "chevron-right",
                                          class: "color-primary"
                                        })
                                      ])
                                    ])
                                  ], 10, _hoisted_10))
                                }), 128))
                              ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.selectedCountryId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_Card, { title: "Carriers" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CustomScrollbar, { "max-height": 400 }, {
                          default: _withCtx(() => [
                            _createVNode(_Transition, {
                              name: "fade",
                              mode: "out-in"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.carriersLoading)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode(_component_AppPreloader)
                                    ]))
                                  : (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carriers, (carrier) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: carrier.id,
                                          class: "country-carriers-list--item mt-2"
                                        }, [
                                          _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                              _createElementVNode("div", _hoisted_22, [
                                                _createVNode(_component_Partner, {
                                                  title: carrier.name,
                                                  image: carrier.image
                                                }, null, 8, ["title", "image"])
                                              ]),
                                              _createElementVNode("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                  _createElementVNode("div", _hoisted_25, [
                                                    _createElementVNode("strong", _hoisted_26, _toDisplayString(carrier.networkGenerationString), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_27, [
                                                    _createElementVNode("div", _hoisted_28, [
                                                      _createVNode(_component_AppButton, {
                                                        type: "primary-transparent",
                                                        size: "icon",
                                                        onClick: ($event: any) => (_ctx.editCarrier(carrier.id))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_SvgIcon, { icon: "pen" })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"]),
                                                      _createVNode(_component_AppButton, {
                                                        type: "danger-transparent",
                                                        size: "icon",
                                                        onClick: ($event: any) => (_ctx.deleteCarrier(carrier.id))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_SvgIcon, { icon: "trash" })
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_AppButton, {
                            size: "xl",
                            type: "primary-border-dashed mt-4",
                            onClick: _ctx.createCarrier
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BtnContent, {
                                icon: "plus",
                                label: "Add Carrier"
                              })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}